import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import {
  Dialog,
  Button,
  DialogContent,
  DialogActions,
  DialogTitle
} from "@mui/material";

export interface AlertProps {
  title: string;
  message: string;
  label?: string;
}

export default NiceModal.create(({ title, message }: AlertProps) => {
  const modal = useModal();

  return (
    <Dialog
      open={modal.visible}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          modal.remove();
        }
      }}
      disableEscapeKeyDown
    >
      <DialogTitle>{title}</DialogTitle>
      {message && <DialogContent>{message}</DialogContent>}
      <DialogActions>
        <Button
          size="small"
          onClick={() => {
            modal.resolve();
            modal.remove();
          }}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
});
